import type { TopClient } from "@src/__generated__/urql-graphql";
import { currency } from "@src/utils/formatters";
import type { Prettify } from "@src/utils/types";
import { action, computed, makeObservable, observable } from "mobx";

type TopClientForGraph = Prettify<
  Omit<TopClient, "brands"> & Record<TopClient["brands"][0]["name"], number>
>;

export class TopClientGraphStore {
  @observable data: TopClient[];

  constructor(data: TopClient[]) {
    makeObservable(this);
    this.data = data;
  }

  @action setData(data: TopClient[]) {
    this.data = data;
  }

  @computed get allBrands(): TopClient["brands"] {
    return this.data.flatMap((item) => item.brands.map((brand) => brand));
  }

  @computed get dataForGraph(): TopClientForGraph[] {
    const newData: TopClientForGraph[] = [];
    const dataCount = this.data.length;

    for (let i = 0; i < dataCount; i++) {
      const item = this.data[i];
      if (!item) continue;
      const brandCount = item.brands.length;

      const simplifiedItem = new Map();

      simplifiedItem.set("title", item.name);
      simplifiedItem.set("total_value", item.total_value);
      simplifiedItem.set(
        "total_value_formatted",
        currency.formatByWorkspace(item.total_value, {
          fractionDigits: 0,
        }),
      );

      for (let j = 0; j < brandCount; j++) {
        const brand = item.brands[j];

        if (!brand) continue;

        simplifiedItem.set(brand.name, brand.value);
      }
      newData.push(Object.fromEntries(simplifiedItem));
    }

    return newData.toSorted((a, b) => (a.total_value < b.total_value ? 1 : -1));
  }
}
